module.exports = __webpack_public_path__ + "img/horizontal_6_6_6000.efbdeb6b.png";